import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { BASE_URL } from '../App';
import '../styles/payment.css';

function Payment() {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    if (location.state && location.state.paymentData) {
      setPaymentData(location.state.paymentData);
      setIsLoading(false);
    } else {
      // إذا لم يتم تمرير بيانات الدفع، ارجع إلى صفحة شحن المحفظة
      navigate('/chargewallet');
    }
  }, [location.state, navigate]);

  const handleBackToWallet = () => {
    navigate('/chargewallet');
  };

  if (isLoading) {
    return (
      <div className="payment-loading">
        <div className="loading-content">
          <h2>جاري تحميل بيانات الدفع...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="payment-page">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <div className="payment-header">
              <h1>كود الدفع - فوري</h1>
              <p>استخدم هذا الكود لدفع المبلغ المطلوب</p>
            </div>
            
            <Card className="payment-card">
              <Card.Body>
                <div className="fawry-code-section">
                  <h3>كود فوري الخاص بك</h3>
                  <div className="code-display">
                    <span className="code-text">{paymentData}</span>
                  </div>
                  <p className="code-instructions">
                    اذهب إلى أقرب فرع فوري أو استخدم تطبيق فوري وادخل هذا الكود
                  </p>
                </div>
                
                <div className="payment-instructions">
                  <h4>تعليمات الدفع:</h4>
                  <ul>
                    <li>احتفظ بهذا الكود</li>
                    <li>اذهب إلى أقرب فرع فوري</li>
                    <li>أو استخدم تطبيق فوري</li>
                    <li>ادخل الكود وادفع المبلغ</li>
                    <li>سيتم إضافة الرصيد لمحفظتك خلال 30-60 دقيقة</li>
                  </ul>
                </div>
                
                <div className="payment-actions">
                  <Button 
                    variant="outline-primary" 
                    onClick={handleBackToWallet}
                    className="back-button"
                  >
                    العودة لشحن المحفظة
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Payment;
